import { AbstractGetAllStore } from "../common/AbstractStores";
import { UserDto } from "../generated";
import Dispatcher from "../common/dispatcher";
import Actions from "./operatorsActions";

class OperatorsStore extends AbstractGetAllStore<UserDto>{
    constructor() {
        super(x => x.codOperatore.toString());
        Dispatcher
            .onfunction(Actions.getOperatoriByEsercente, result => this.updateOrAddAll(result))
            .onfunction(Actions.update, result => this.updateOrAdd(result))
            ;
    }
    public useAll = () => this.useAllWithAction(() => Actions.getOperatoriByEsercente());
}

export default new OperatorsStore()
